var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 637,
    viewBox: "0 0 1920 637",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1368.34 -749.415C1628.37 -636.828 1941.52 -631.314 2134.77 -443.436C2328.79 -254.808 2351.8 -18.1246 2291.69 148.27C2236.59 300.783 1986.4 308.98 1831.62 395.724C1688.7 475.817 1628.08 638.885 1420.52 636.487C1207.96 634.031 979.15 474.732 751.359 383.241C453.28 263.52 48.2543 248.743 -117.877 18.5972C-285.891 -214.157 55.1116 -331.999 85.4682 -539.236C111.418 -716.388 -103.29 -987.905 45.2674 -1095.15C193.55 -1202.19 511.797 -1101.68 770.818 -1033.99C980.307 -979.249 1161.69 -838.888 1368.34 -749.415Z",
    fill: "url(#paint0_linear_1219_24336)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_24336",
    x1: 2084.42,
    y1: -303.53,
    x2: -140.319,
    y2: 308.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ECAE6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#8ECAE6",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8ECAE6",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8ECAE6",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ECAE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgimg);
export default __webpack_public_path__ + "static/media/bgimg.d925ddeceaaded5a618ff78583eb3f16.svg";
export { ForwardRef as ReactComponent };